import '../scss/style.scss';

(function(window, document, $) {

    $(document).ready(function($){

        // Desktop 
        // =======================================================
        if (window.matchMedia("(min-width: 1200px)").matches) {
        }

        // Mobile
        // ========================================================

        // Subnavigation Mobile
        // ========================
        $('.main-nav li.menu-item-has-children').click(function(e) {

            // Let clicks inside the sub-menu (child links, backlink) bubble normally
            if ($(e.target).closest('.sub-menu').length > 0) return;

            e.preventDefault();
            $(".main-nav li.menu-item-has-children").not(this).removeClass("this-open");
            $(this).toggleClass('this-open');
        });

        // add nav-back
        $('.main-nav li a').each(function(i) {
            if ($(this).siblings('.sub-menu').length > 0) {
                //$(this).siblings('.sub-menu').prepend($('<li class="menu-item back-item"></li>').append($(this).clone()));
                $(this).siblings('.sub-menu').prepend($('<li class="backlink"></li>').append($(this).clone()));
            }
        });

        // close subnav
        $('.backlink').click(function(e) {
            e.preventDefault();
            $(this).closest('.menu-item-has-children').removeClass("this-open");
        });

        // Hamburger
        // ========================================================
        $('.hamburger').click(function() {
            window.scrollTo(0,0);
            $(this).toggleClass('is-active');
            $('#header').toggleClass('open');
            $('body').toggleClass('no-scroll');
        });

        // Grid button
        // ========================================================
        $('.grid-button').click(function() {
            if ($('#grid-overlay').length > 0) {
                $('#grid-overlay').remove()
            } else {
                $('#page').prepend('<div id="grid-overlay"><div class="row"><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div><div class="col"></div></div></div>');
            }
        });

        // Toggle Persons biography
        // ========================================================
        $('.person .toggle').click(function() {
            $(this).parent('.biography').toggleClass('open');
        });

        // Copy permalink share button
        // ========================================================
        $(document).on('click', '.share-button', function () {
            var $button = $(this);
            var url     = $button.data('share-url');
            if ( ! url ) return;

            var showCopied = function () {
                $button.addClass('is-copied');
                setTimeout(function () { $button.removeClass('is-copied'); }, 2000);
            };

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(showCopied).catch(function () {});
                return;
            }

            var textarea = document.createElement('textarea');
            textarea.value             = url;
            textarea.style.position    = 'fixed';
            textarea.style.opacity     = '0';
            textarea.setAttribute('readonly', '');
            document.body.appendChild(textarea);
            textarea.select();
            try {
                document.execCommand('copy');
                showCopied();
            } catch (e) {}
            document.body.removeChild(textarea);
        });

    });


    // Declaration scroll automatically
    // ========================================================
     var $ticker = $(".petition-ticker");
  var $track = $(".petition-track");
  var $items = $(".petition-name");

  var itemWidth = $items.outerWidth(true);
  var totalWidth = itemWidth * $items.length;

  // Items klonen für Endlos-Effekt
  $track.append($items.clone());

  var pos = 0;
  var speed = 1;        // Geschwindigkeit (Pixel pro Frame)
  var paused = true;    // Startzustand: pausiert
  var startDelay = 2000; // 2000 ms = 2 Sekunden warten, bevor es losläuft

  // Animation
  function animate() {
    if (!paused) {
      pos -= speed;
      if (Math.abs(pos) >= totalWidth) {
        pos = 0; // Reset
      }
      $track.css("transform", "translateX(" + pos + "px)");
    }
    requestAnimationFrame(animate);
  }

  // Hover-Events
  $ticker.on("mouseenter", function() {
    paused = true;
  });
  $ticker.on("mouseleave", function() {
    paused = false;
  });

  // Nach Delay starten
  setTimeout(function() {
    paused = false;
  }, startDelay);

  animate();

})(window, document, jQuery);

// Viewport-Height
function setAppHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
}

window.addEventListener('resize', setAppHeight);
window.addEventListener('orientationchange', setAppHeight);
setAppHeight();
